const SDK_VERSION = '7.119.2';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
